export default "__VITE_ASSET__5XWremop__"